import { Component, ElementRef, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { handleApiError } from 'src/app/utils/error';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { ApplicationsApiService } from 'src/app/services/api/applications-api.service';
import { FileApiService } from 'src/app/services/api/file-api.service';
import { GetAssetFileFromApplicationResponseModel } from 'src/app/models/files.model';

@Component({
  selector: 'app-file-list',
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
})
export class FileListComponent {
  @Input() control!: FormArray;
  @Input() applicationId!: number;
  @Input() uploaderName!: string;
  @Input() uploadedFileLabel!: string;
  @Input() isSummary!: boolean;
  @Input() genericPrefix = '';

  modalOpen!: boolean;
  error = '';

  constructor(
    private fileApiService: FileApiService,
    private applicationsApiService: ApplicationsApiService,
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {}

  openDialog(event: any, index: number): void {
    const target = new ElementRef(event.currentTarget);
    const dialogRef = this.dialog.open(DialogComponent, {
      maxWidth: '400px',
      data: {
        question: this.translateService.instant(
          'accountingUpload.removeFile.question',
          { filename: this.getFilename(index).slice(this.genericPrefix.length) }
        ),
        yes: this.translateService.instant('accountingUpload.removeFile.yes'),
        no: this.translateService.instant('accountingUpload.removeFile.no'),
        trigger: target,
      },
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.handleFileRemove(index);
      }
    });
  }

  downloadFile(filename: string): void {
    this.fileApiService
      .getAssetFileFromApplication(
        this.applicationId,
        this.uploaderName,
        filename
      )
      .subscribe(
        (response: GetAssetFileFromApplicationResponseModel) => {
          window.open(response.url, '_blank');
        },
        (error: any) => handleApiError(error, this.translateService)
      );
  }

  handleFileRemove(index: number): void {
    this.applicationsApiService
      .removeAssetFileFromApplication({
        applicationId: this.applicationId,
        name: this.uploaderName,
        fileName:
          this.control.value[index].name || this.control.value[index].filename,
      })
      .subscribe(
        () => {
          this.error = '';
        },
        (error: any) => handleApiError(error, this.translateService)
      );
    this.control.removeAt(index);
  }

  getFilename(index: number): string {
    const { value } = this.control;
    return value[index].name || value[index].filename;
  }
}
